import { gql } from "@apollo/client";

export const GETALERTS =gql`
query getAlerts {
    getAlerts {
        success
        messages
        alerts {
            isDuplicateAccount
            shouldShowWellnessUpSell
            shouldShowPrequalification
            urgentVisitUpSell
            referralUpSell
            isExpressEligible {
                petName
                imageUrl
                userId
            }
            updatePaymentMethod {
                petName
                image
                animalId
                alertType
            }
            overdueORLastMonthOverDueWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            endsSoonWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            recentlyEndedWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            overdueCancelledWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            recentRenewedWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            failedRenewalsAfterGracePeriodWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            failedRenewalsWithGracePeriodWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            failedRenewalsWPData {
                petId
                petName
                petImage
                species
                wellnessId
                endDate
                startDate
                nextRenewal
                nextBillingDate
                last4digit
                price
                isAutoRenewal
                wellnessPlanName
                renewalStatus
                pendingEzyvetInvoices
                planName
                planType
                subscriptionId
                isScratchpay
                pendingSquareInvoices {
                    invoiceId
                    invoiceNumber
                    subscriptionId
                    orderId
                    publicUrl
                    customerId
                    email
                    amount
                    currency
                    status
                    dueDate
                    description
                    contactId
                    animalId
                    schemaName
                    createdAt
                    updatedAt
                }
            }
            scratchpayRenewalPending {
                petId
                petName
                petImage
                species
                endDate
                planName
                planType
                subscriptionId
                isScratchpay
                scratchpayPlanId
            }
        }
    }
}
`;

